export const getProductId = (store)=>store.productDetail.productId;
export const getSelecetdProduct = (store)=>store.productDetail.productDetail